/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconSecure({ className, style }){
  return(
    <svg className={className} fill="none" height="14" style={style} viewBox="0 0 20 20" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2774 2.08397C10.1094 1.97201 9.8906 1.97201 9.72265 2.08397C7.78446 3.3761 5.68833 4.1823 3.42929 4.50503C3.18296 4.54021 3 4.75117 3 5V9.5C3 13.3913 5.30699 16.2307 9.82051 17.9667C9.93605 18.0111 10.064 18.0111 10.1795 17.9667C14.693 16.2307 17 13.3913 17 9.5V5C17 4.75117 16.817 4.54021 16.5707 4.50503C14.3117 4.1823 12.2155 3.3761 10.2774 2.08397ZM11.5 9C11.5 9.65311 11.0826 10.2087 10.5 10.4146V12.5C10.5 12.7761 10.2761 13 10 13C9.72386 13 9.5 12.7761 9.5 12.5V10.4146C8.9174 10.2087 8.5 9.65311 8.5 9C8.5 8.17157 9.17157 7.5 10 7.5C10.8284 7.5 11.5 8.17157 11.5 9Z" fill="currentColor"/>
    </svg>
  );
}
IconSecure.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};
